import React, { useState, useEffect, useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import _ from 'lodash';
import { useTranslator } from '@jutro/locale';
import { IntlContext } from '@jutro/locale';
import styles from './WizardPageHeader.module.scss';
import moment from 'moment';
import messages from './WizardPageHeader.messages';
import { Link } from '@jutro/router';


const QUOTE_TRANSACTION = [
    'CommercialProperty',
    'WC7WorkersComp',
    'Homeowners',
    'BusinessOwners',
    'PersonalAuto',
    'HOPHomeowners'
];

const WizardPageHeader = (props) => {
    const translator = useTranslator();
    const [wizardHeaderTemplate, setWizardHeaderTemplate] = useState('');
    const [routePath, setRoutePath] = useState('');
    const [accountName, setAccountName] = useState('');
    const [lobWithQuoteNumber, setLobWithQuoteNumber] = useState('');
    const {
        wizardSubmission, isSideHeader, lobFlow, displayWizardHeader
    } = props;

    useEffect(() => {
        const productCode = _.get(wizardSubmission.value, 'baseData.productCode');
        const jobType = _.get(wizardSubmission.value, 'baseData.jobType');
        const lob = (jobType === 'Renewal' && `${productCode}${jobType}`)
            || (jobType === 'PolicyChange' && `${productCode}${jobType}`)
            || productCode;
        const accountNumber = _.get(wizardSubmission.value, 'baseData.accountNumber');
        const getFirstName = _.get(wizardSubmission.value, 'baseData.accountHolder.firstName') || '';
        const getLastName = _.get(wizardSubmission.value, 'baseData.accountHolder.lastName') || '';
        const getDisplayName = _.get(wizardSubmission.value, 'baseData.accountHolder.displayName');
        const getAccountDisplayName = !getDisplayName
            ? `${getFirstName} ${getLastName}`
            : getDisplayName;
        const getAccountName = _.trim(getAccountDisplayName)
            || _.get(wizardSubmission.value, 'baseData.accountHolder.contactName')
            || _.get(wizardSubmission.value, 'baseData.accountName');

        if (lob && QUOTE_TRANSACTION.includes(productCode)) {
            setWizardHeaderTemplate('transaction');
        }
        else{
            setWizardHeaderTemplate('claim');
        }
        // wizardSubmission._dtoName='fnol'
        // console.log("wizard submission dto name ", wizardSubmission._dtoName)
        /* eslint no-underscore-dangle: 0 */
        // if (wizardSubmission._dtoName.indexOf('fnol') !== -1) {
        //     setWizardHeaderTemplate('claim');
        // }

        setRoutePath(`/accounts/${accountNumber}/summary`);
        setAccountName(getAccountName);
        // If the current wizard screen is the non-STP quote screen, change the header message from the default used in the other screens in the flow
        const messageKey = lobFlow == 'nonSTPQuote' ? `${_.camelCase(lob)}ReadyToSubmit` : _.camelCase(lob)
        setLobWithQuoteNumber(
            translator(messages[messageKey], {
                quoteNumber:
                    _.get(wizardSubmission.value, 'quoteID')
                    || _.get(wizardSubmission.value, 'policyNumber'),
                jobId: _.get(wizardSubmission.value, 'jobID') || ''
            })
        );
    }, [lobFlow, translator, wizardSubmission]);

    const titleContainerClass = cx({
        [styles.gwWizardPageTitle]: !isSideHeader,
        [styles.gwWizardSidePageTitle]: isSideHeader
    });

    const categoryContainerClass = cx({
        [styles.gwWizardPageCategory]: !isSideHeader,
        [styles.gwWizardSidePageCategory]: isSideHeader
    });

    const associatedPageClass = cx({
        [styles.gwWizardPageAssociated]: !isSideHeader,
        [styles.gwWizardSidePageAssociated]: isSideHeader
    });

    const titleSeparator = isSideHeader && (
        <div className={styles.gwWizardSidePageTitleSeparator} />
    );

    const submissionQuote = wizardHeaderTemplate === 'transaction' && (
        <div className={titleContainerClass}>
            <div className={categoryContainerClass}>
                {translator(messages.accountTitle)}
                <Link className={associatedPageClass} to={routePath}>
                    {accountName}
                </Link>
            </div>
            {titleSeparator}
            {displayWizardHeader ? (
                <h1 className={cx(styles.wizardPageHeader, { [styles.gwWizardSidepageTitle]: isSideHeader })}>
                    {lobWithQuoteNumber}
                </h1>
            ) : (
                ''
            )}
        </div>
    );

    const claimHeader = useCallback(() => {
        const claimNumber = _.get(wizardSubmission.value, 'claimNumber', '');
        const intl = useContext(IntlContext);
        const dateOfInjury = (wizardSubmission?.lossDate?.value!=undefined) ? intl.formatDate(intl.formatDate(moment(wizardSubmission?.lossDate?.value).toDate().toUTCString(), { year: 'numeric', month: 'numeric', day: 'numeric' })):""
         const injuredName = wizardSubmission?.lobs?.workersComp?.injuryIncident?.injured?.displayName?.value;
         let injureDisplayName = (injuredName!=undefined && injuredName!="") ? injuredName : ""
         let donotShowDOI = wizardSubmission?.fnolSelectPolicyPage?.value
        if(dateOfInjury!="" && donotShowDOI!="true"){
        return wizardHeaderTemplate === 'claim' ? (
            <>
                <h1 className={styles.gwPageTitle}>
                    {translator(messages.fnolNewClaim)}
                    <span className={styles.gwClaimsWizardSpanNumber}>{claimNumber}</span>

                </h1>
               <div className={styles.gwPageTitle}>
               <div >
                    <span className={styles.wizardSubTitle}>{injureDisplayName}</span>
                </div>
                <div >
                   <span className={styles.wizardSubTitle} >{translator(messages.dateOfInjury) }</span>
                    <span className={styles.wizardSubTitle}>{dateOfInjury}</span>
                    
                </div>
                </div> 
            </>
        ) : null;
    }else {
        return wizardHeaderTemplate === 'claim' ? (
            <>
                <h1 className={styles.gwPageTitle}>
                    {translator(messages.fnolNewClaim)}
                    <span className={styles.gwClaimsWizardSpanNumber}>{claimNumber}</span>

                </h1>
               
            </>
        ) : null;
    }
    }, [wizardHeaderTemplate, translator, wizardSubmission?.value]);

    return (
        <>
            {submissionQuote}
            {claimHeader()}
        </>
    );
};

WizardPageHeader.propTypes = {
    wizardSubmission: PropTypes.shape({
        value: PropTypes.shape({}),
        _dtoName: PropTypes.string
    }).isRequired,
    isSideHeader: PropTypes.bool,
    lobFlow: PropTypes.string,
    displayWizardHeader: PropTypes.bool
};

WizardPageHeader.defaultProps = {
    isSideHeader: false,
    lobFlow: '',
    displayWizardHeader: true
};

export default WizardPageHeader;
